import React, { useEffect, useMemo, useRef } from 'react';

import { PropTypes } from 'prop-types';
import useDataFetch from '../../../../hooks/useDataFetch';
import storePropTypes from '../../../../redux/store/propTypes';
import { getFilterQueryParams, getHttpHeader } from '../../../../util/FetchTools';
import { TROUBLESHOOTING_VIEW } from '../../../../constants/general';

function IngestService({ ingestInput, url, orgaHash, cancelToken, onResult }) {
   const body = ingestInput;
   const ingestPropName = Object.keys(ingestInput)[0];

   const header = useMemo(() => getHttpHeader(orgaHash), [orgaHash]);
   const streamFilterArray = useMemo(() => [ingestInput[ingestPropName]], [ingestInput, ingestPropName]);

   // streamFilterArray gets appended to the URL query params for logging purposes only on BE side
   const urlFilterQuery = getFilterQueryParams([], [], [], streamFilterArray, TROUBLESHOOTING_VIEW);
   const urlWithFilters = url + urlFilterQuery;

   const { successful, isLoading, errorMessage, httpStatus, data } = useDataFetch(urlWithFilters, {
      method: 'POST',
      body,
      header,
      cancelToken,
   });

   // Held in a ref because the parent re-creates it every render, and called from an effect because it sets parent state.
   const onResultRef = useRef(onResult);
   onResultRef.current = onResult;

   useEffect(() => {
      if (successful) {
         onResultRef.current({ isLoading, httpStatus, untouched: false, data: data.result });
      } else if (errorMessage) {
         onResultRef.current({ isLoading, error: errorMessage, untouched: false });
      } else {
         onResultRef.current({ untouched: true, isLoading });
      }
   }, [successful, isLoading, errorMessage, httpStatus, data]);

   return <></>;
}

IngestService.propTypes = {
   ingestInput: PropTypes.object,
   url: PropTypes.string,
   orgaHash: PropTypes.string,
   cancelToken: storePropTypes.cancelToken,
   onResult: PropTypes.func,
};

export default IngestService;
